import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { Strings } from '../../utils/resources/strings';
import { APIProcessorImpl } from './apiProcessor';
import { PlayPauseFlashMessageRequest } from '../api/flashmessage/playpause/playpauseflashmessagesrequest';
import { PlayPauseFlashMessageResponse, PlayPauseFlashMessageResponseDtoImpl } from '../api/flashmessage/playpause/playpuaseflashmessagesresponse';

export class PlayPauseFlashMessageAPIProcessorImpl extends APIProcessorImpl<PlayPauseFlashMessageRequest, PlayPauseFlashMessageResponse>
{
    // execute(request: PlayPauseFlashMessageRequest): void {
    //     let response = new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, "PlayPause PlayPauseFlashMessage Success");
                
    //     // response.setFlashMessageResponseDtos(new FlashMessageBuilder(responseMapper.getResponseMap()).buildAll())
        
    //     this.getAPISuccess(response);
    // }
    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) 
            {
                if(+responseMapper.getStatusCodeOutside() === 0)
                {
                let response = new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, "PlayPause PlayPauseFlashMessage Success");
                
                // response.setFlashMessageResponseDtos(new FlashMessageBuilder(responseMapper.getResponseMap()).buildAll())
                
                this.getAPISuccess(response);
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.NO_CONTENT)
                {
                    this.getAPISuccess(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
                }
                else if(+responseMapper.getStatusCodeOutside() === StatusCodes.INTERNAL_SERVER_ERROR)
                {
                    this.getAPIFailure(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
                }
                else
                {
                    this.getAPIFailure(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, responseMapper.getStatusMsg()));
                }
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.NO_CONTENT)
            {
                this.getAPISuccess(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.no_data_list_available)));
            }
            else if(+responseMapper.getStatusCode() === StatusCodes.INTERNAL_SERVER_ERROR)
            {
                this.getAPIFailure(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
            }
        }
        catch (e) {
            this.getAPIFailure(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
      
            this.getAPIFailure(new PlayPauseFlashMessageResponseDtoImpl(APIFeatures.PLAYPAUSE_FLASH_MESSAGE, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/playpauseflashmessagesapiprocessor.tsx